var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"tag":"footer"}},[_c('v-col',{staticClass:"\n      py-0\n      primary--text\n    "},[_c('h3',{staticClass:"mb-6",class:{
        'headline-2': _vm.$vuetify.breakpoint.smAndUp,
        'headline font-weight-medium': _vm.$vuetify.breakpoint.xs
      },domProps:{"innerHTML":_vm._s(_vm.config.home_footer_title)}}),_c('div',{class:{
        'body-2': _vm.$vuetify.breakpoint.xs
      },domProps:{"innerHTML":_vm._s(_vm.config.home_footer_text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }